package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.DisplayVerticalOutline: ImageVector
    get() {
        if (_displayVerticalOutline != null) {
            return _displayVerticalOutline!!
        }
        _displayVerticalOutline = Builder(name = "DisplayVerticalOutline", defaultWidth = 24.0.dp,
                defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(16.0f, 2.0f)
                horizontalLineTo(8.0f)
                curveTo(6.89f, 2.0f, 6.0f, 2.89f, 6.0f, 4.0f)
                verticalLineTo(16.0f)
                curveTo(6.0f, 17.11f, 6.9f, 18.0f, 8.0f, 18.0f)
                horizontalLineTo(10.0f)
                verticalLineTo(20.0f)
                horizontalLineTo(8.0f)
                verticalLineTo(22.0f)
                horizontalLineTo(16.0f)
                verticalLineTo(20.0f)
                horizontalLineTo(14.0f)
                verticalLineTo(18.0f)
                horizontalLineTo(16.0f)
                curveTo(17.11f, 18.0f, 18.0f, 17.11f, 18.0f, 16.0f)
                verticalLineTo(4.0f)
                curveTo(18.0f, 2.89f, 17.1f, 2.0f, 16.0f, 2.0f)
                moveTo(16.0f, 16.0f)
                horizontalLineTo(8.0f)
                verticalLineTo(4.0f)
                horizontalLineTo(16.0f)
                verticalLineTo(16.0f)
                close()
            }
        }
        .build()
        return _displayVerticalOutline!!
    }

private var _displayVerticalOutline: ImageVector? = null
